import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../axiosInterceptor';

type UpdateBookingStatusPayload = {
  studentId: string;
  status: string;
};

type UpdateBookingStatusState = {
  loading: boolean;
  updatingId: string | null;
  error: boolean;
  errorMessage: string;
  data: unknown | null;
};

const initialState: UpdateBookingStatusState = {
  loading: false,
  updatingId: null,
  error: false,
  errorMessage: '',
  data: null,
};

export const updateBookingStatus = createAsyncThunk<
  unknown,
  UpdateBookingStatusPayload
>('updateBookingStatus', async ({ studentId, status }) => {
  if (!studentId) {
    throw new Error('Missing student ID.');
  }
  const { data } = await api.post(`/api/bookings/${studentId}/status`, {
    status,
  });
  return data;
});

const updateBookingStatusSlice = createSlice({
  name: 'updateBookingStatus',
  initialState,
  reducers: {
    resetUpdateBookingStatus: (state) => {
      state.loading = false;
      state.updatingId = null;
      state.error = false;
      state.errorMessage = '';
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateBookingStatus.pending, (state, action) => {
      state.loading = true;
      state.updatingId = action.meta.arg.studentId;
      state.error = false;
      state.errorMessage = '';
    });
    builder.addCase(updateBookingStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.updatingId = null;
      state.data = action.payload;
    });
    builder.addCase(updateBookingStatus.rejected, (state, action) => {
      state.loading = false;
      state.updatingId = null;
      state.error = true;
      state.errorMessage =
        action.error.message ?? 'Failed to update booking status.';
    });
  },
});

export const { resetUpdateBookingStatus } = updateBookingStatusSlice.actions;
export default updateBookingStatusSlice.reducer;
